module.exports = __webpack_public_path__ + "img/kalis_login_logo.d6398082.svg";